import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface RequirePermissionProps {
  permission: string;
  children: React.ReactElement;
}

export const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  children,
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se o usuário tem a permissão necessária
  const hasPermission = user.permissions?.includes(permission);

  if (!hasPermission) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};
